<script>
import { gql } from "graphql-tag";
import { mapState, mapActions } from "vuex";
import NoticiasList from "@/components/intranet/noticias/NoticiasList.vue";
import Paginador from "@/components/layout/Paginador.vue";
import IconNoticias from "@/assets/img/icon/section/IconNoticias.vue";

export default {
  name: "Noticias",
  components: {
    Paginador,
    NoticiasList,
    IconNoticias
  },
  data() {
    return {
      loading: true,

      isHidden: true,
      selectedCategoria: "0",
      selectedCategoriaText: "Todas",
      butonActive: true,

      //FF
      filter: {
        visibles: "1",
        search: "",
        pagina: 1,
        limite: "16",
        categoria: { 
          id_categoria: "0", 
          nombre_categoria: "Todas" 
        }
      },
      heightWindow: 0
    };
  },
  apollo: {
    categorias: {
      query: gql`
        query {
          categorias(id_empresa: "1") {
            id_categoria
            nombre_categoria
          }
        }
      `,
    },
  },
  computed:{
    ...mapState("NoticiasModules", ["paginadorNoticiasIntranet", "noticiasPaginadas"]),
  },
  methods: {
    ...mapActions("NoticiasModules", ["getPaginacionNoticias", "getNoticiasPaginadas"]),
    changeCategoria(id, nombre) {
      this.selectedCategoria = id;
      this.selectedCategoriaText = nombre;
    },
    //FF
    async getNoticias() {
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        id_usuario: this.$ls.get("user").id_usuario,
        nombre: this.filter.search,
        id_categoria: this.filter.categoria.id_categoria,
        recien_visto: this.filter.visibles,
        limite: this.filter.limite
      }
      
      await this.getPaginacionNoticias(data_).then(res=> {
          if (res) {
              res.forEach((data) => {
              if (data.pagina == this.filter.pagina) {
                this.ids_noticias = data.noticias;
                this.getNoticiasPaginada(data.noticias);
                //console.log(this.ids_noticias);
              }
            });   
          }else{
              this.getNoticiasPaginada([]);
          }
          //console.log("Acá en paginación: ", res);
      });    
    },
    async getNoticiasPaginada(id_noticias){
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        id_usuario: this.$ls.get("user").id_usuario,
        id_noticias: id_noticias
      }
      
      console.log("getPaginacionNoticias: ",data_);
      this.loading = true;
      await this.getNoticiasPaginadas(data_);
      this.loading = false;
    },
    changePage(pagina, total) {
      if (pagina < 1) pagina = 1;
      if (pagina > total) pagina = total;
      this.filter.pagina = pagina;
    },
    updatePage(page) {
      this.filter.pagina = page;
    },
    windowsHeight() {
        let mediaQuery = window.matchMedia('(min-width: 992px)');
        let height = window.innerHeight;
        if (mediaQuery.matches) this.heightWindow = height -480 + "px";
        else this.heightWindow = "auto";
			},
  },
  watch: {
    "filter.pagina"() {
      this.getNoticias();
      //this.loading = !this.loading;
    },
    "filter.visibles"() {
      this.getNoticias();
    },
    "filter.categoria"() {
      this.getNoticias();
    },
    "filter.search"() {
      this.getNoticias();
    }
  },
  created(){
    this.getNoticias();
  },
  mounted() {
    this.windowsHeight();
    window.addEventListener('resize', this.windowsHeight);
  },
};
</script>

<template>

  <section id="noticias">

    <div class="row">
      <div class="col-12 mb-0">
        <h1 class="h1-custom font-700 mb-1 text-capitalize color-main d-flex align-items-center">
          <IconNoticias class="me-2 icon-svg-45"/>
          Noticias
        </h1>
  
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link 
                to="/home"
                class="color-main"
              >
                <font-awesome-icon icon="fa-solid fa-house"></font-awesome-icon>
                Inicio
              </router-link>
            </li>
            <li class="breadcrumb-item text-capitalize active">
              Noticias
            </li>
          </ol>
        </nav>
      </div>
    </div>
  
    <div class="row d-flex mt-2">
      <div class="col-12 col-lg-8 mb-3 mb-lg-0 d-flex align-items-center">
        <p class="text-secondary h5-custom mb-0">
          ¡Entérate de todas nuestras novedades! Filtra las noticias seleccionando una categoría.
        </p>
      </div>
      <div class="col-12 col-lg-4 text-end">
        <div 
          class="btn-group btn-group-custom" 
          role="group"
        >
          <input 
            value="1"
            v-model="filter.visibles"
            type="radio" 
            class="btn-check btn-group-custom-check" 
            name="filtro-noticias" 
            id="radio-recientes" 
            autocomplete="off" 
            checked
          >
          <label 
            class="btn btn-group-custom-label" 
            for="radio-recientes">
            Recientes
          </label>

          <input 
            value="2"
            v-model="filter.visibles"
            type="radio" 
            class="btn-check btn-group-custom-check" 
            name="filtro-noticias" 
            id="radio-mas-vistos" 
            autocomplete="off"
          >
          <label 
            class="btn btn-group-custom-label" 
            for="radio-mas-vistos"
            >
            Más vistos
          </label>
        </div>     
      </div>
    </div>
  
    <div class="row">
      <div class="col-12">
        <div class="border-bottom mb-3 pb-3"></div>
      </div>
    </div> 
  
      <div class="row">
        <div class="col-12">
          <div class="row mb-3">
            <div class="col-12 col-lg-3 input-display input-display-left mb-3 m-lg-0">
              <input 
                type="search" 
                class="form-control input-filter" 
                placeholder="Buscar"
                v-model="filter.search"
              >
              <font-awesome-icon icon="fa-solid fa-magnifying-glass" class="input-display-icon color-gray" ></font-awesome-icon> 
            </div>
            <div class="col-12 col-lg-3">
              <v-select
                :options="categorias"
                v-model="filter.categoria"
                label="nombre_categoria"
                placeholder="Categorías"
                class="vue-select"
                :clearable="false"
              >
              </v-select>
            </div>
          </div>
  
          <div 
            class="row over-y mb-4"
            :style="`height: ${heightWindow}`"
          >
            <div class="col-12">
              <NoticiasList 
                :loading="loading"
                :data="noticiasPaginadas"
              />
            </div>
          </div>
  
          <Paginador
            :data="paginadorNoticiasIntranet"
            :page="filter.pagina"
            @updatePage="updatePage"
          />
  
        </div>
      </div>
  </section>


</template>
